const TextButton = (props) => {
    const { onClick, labelText } = props

    return (
        <button
            style={{ marginLeft: '10px' }}
            className="btn btn--animated btn--white"
            onClick={(event) => onClick()}
        >
            {labelText}
        </button>
    )
}

export default TextButton